export const SYSTEM_PROJECT_TYPES = [
    'Technology Due Diligence',
    'Vendor Due Diligence',
    'IT M&A Advisory',
    'Post-Merger Integration',
    'Due Diligence & Integration',
    'Technology Transformation',
    'Technology Coaching',
    'Cybersecurity Assessment',
    'Tech Advisory',
    'Custom',
];

export const DEFAULT_WORKSPACE_PROJECT_TYPES = [
    'Technology Due Diligence',
    'Vendor Due Diligence',
    'IT M&A Advisory',
    'Post-Merger Integration',
    'Due Diligence & Integration',
];

export const DEFAULT_PROJECT_TYPE_COLOR = '#c89741';

export function isSystemProjectType(name) {
    return SYSTEM_PROJECT_TYPES.includes(name);
}

export function toProjectTypeOptions(names) {
    return names.map(name => ({ name, color: DEFAULT_PROJECT_TYPE_COLOR }));
}

export function normalizeProjectTypeOptions(options) {
    if (!Array.isArray(options)) return [];
    return options
        .filter(option => option && option.name)
        .map(option => ({
            name: option.name,
            color: option.color || DEFAULT_PROJECT_TYPE_COLOR,
        }));
}

/** Active workspace types for project create/edit/filter dropdowns (never the full catalog). */
export function resolveWorkspaceProjectTypeSelectOptions(workspaceOrOptions, { includeValue } = {}) {
    const options = Array.isArray(workspaceOrOptions)
        ? workspaceOrOptions
        : workspaceOrOptions?.project_type_options;
    const normalized = normalizeProjectTypeOptions(
        Array.isArray(options) && options.length ? options : toProjectTypeOptions(DEFAULT_WORKSPACE_PROJECT_TYPES),
    );

    const seen = new Set();
    const selectOptions = [];
    const addOption = name => {
        const label = (name || '').trim();
        if (!label || seen.has(label)) return;
        seen.add(label);
        selectOptions.push({ value: label, text: label, label });
    };

    normalized.forEach(option => addOption(option.name));
    if (includeValue) addOption(includeValue);

    return selectOptions;
}

export function projectTypeNamesFromOptions(options) {
    return normalizeProjectTypeOptions(options).map(option => option.name);
}

export function getCustomProjectTypes(projectTypes) {
    const activeNames = new Set(projectTypeNamesFromOptions(projectTypes));
    return [...activeNames].filter(name => !isSystemProjectType(name));
}
